import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { applySeo } from "@/lib/seo";

export default function About() {
  useEffect(() => {
    applySeo({
      title: "Über uns – Grüne Geldanlage",
      description: "Die Redaktion von Grüne Geldanlage: private Investoren, Finanzjournalisten und unabhängige Berater – redaktionelle Grundsätze, Arbeitsweise und klare Abgrenzung zur Anlageberatung.",
      canonicalPath: "/ueber-uns",
    });
  }, []);
  return (
    <div className="min-h-screen bg-brand-paper" data-testid="about-page">
      <Header />
      <section className="max-w-4xl mx-auto px-6 lg:px-10 pt-20 pb-24">
        <div className="overline mb-4">Über uns</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light leading-tight tracking-tight text-brand-dark mb-10">Wer wir sind, was wir tun – und was wir bewusst nicht sind.</h1>

        <div className="aspect-[16/9] overflow-hidden bg-neutral-100 mb-12">
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/api/images/about-team.jpg`}
            alt="Drei Redaktionsmitglieder im Fachgespräch über Nachhaltigkeitsberichte am Konferenztisch"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="prose-editorial max-w-none">
          <h2>Unsere Mission</h2>
          <p>
            Grüne Geldanlage ist ein deutschsprachiges Fachportal für nachhaltige Geldanlagen.
            Unsere Mission: Wir wollen Privatanlegern verlässliche, journalistisch aufbereitete
            Informationen zu ESG-Investments, grünen ETFs, Impact Investing und regulatorischen
            Entwicklungen bieten – ohne Marketing-Kosmetik, ohne Greenwashing-Sprache und ohne
            versteckte Provisionsinteressen.
          </p>

          <h2>Die Redaktion</h2>
          <p>
            Hinter Grüne Geldanlage steht keine Einzelperson mit Guru-Anspruch, sondern eine
            Redaktion. Sie setzt sich aus drei Perspektiven zusammen, die wir bewusst
            zusammenbringen, weil sie sich gegenseitig ergänzen und korrigieren:
          </p>
          <ul>
            <li><strong>Private Investoren</strong> mit langjähriger eigener Erfahrung in nachhaltigen Geldanlagen, die die praktische Sicht des Anlegers einbringen.</li>
            <li><strong>Finanzjournalisten</strong> mit Schwerpunkt Nachhaltigkeit und ESG, die redaktionelle Standards, Recherchehandwerk und Quellenprüfung verantworten.</li>
            <li><strong>Unabhängige Finanzberater</strong>, die regulatorische und produktseitige Detailfragen einordnen – ohne Verkaufsinteresse an einzelnen Produkten.</li>
          </ul>
          <p>
            Wir arbeiten kollegial: Jeder Artikel wird von mindestens zwei Redaktionsmitgliedern
            aus unterschiedlichen dieser Perspektiven gelesen, bevor er erscheint.
          </p>

          <h2>Redaktionelle Grundsätze</h2>
          <ol>
            <li><strong>Unabhängigkeit.</strong> Wir sind nicht an Fondsanbieter, Depotbanken oder Ratingagenturen gebunden. Kooperationen kennzeichnen wir transparent.</li>
            <li><strong>Keine versteckte Werbung.</strong> Sollten Beiträge Affiliate- oder Partnerlinks enthalten, weisen wir das ausdrücklich zu Beginn des Artikels aus.</li>
            <li><strong>Keine individuelle Anlageberatung.</strong> Unsere Inhalte sind allgemeine Information und Bildung. Wir treffen keine Aussagen zu Ihrer persönlichen finanziellen Situation.</li>
            <li><strong>Quellentransparenz.</strong> Fakten belegen wir mit Primärquellen: Prospekte, Regulierungsdokumente, wissenschaftliche Studien.</li>
            <li><strong>Aktualisierungspflicht.</strong> Ändert sich die Rechtslage oder die Marktrealität, aktualisieren wir Artikel – sichtbar mit Datum.</li>
          </ol>

          <h2>Arbeitsweise</h2>
          <p>
            Themenauswahl, Recherche und Redaktion folgen einem festen Prozess: Zunächst prüfen
            wir, ob es zu einem Thema belastbare Datenquellen gibt. Anschließend führen wir
            Recherchen entlang von Primärquellen (Fondsprospekte, ESMA-Guidelines,
            BaFin-Publikationen, wissenschaftliche Literatur) und ergänzen sie durch mindestens
            zwei unabhängige Sekundärquellen. Vor Veröffentlichung durchläuft jeder Text ein
            redaktionelles Vier-Augen-Prinzip.
          </p>

          <h2>Was wir nicht sind</h2>
          <p>
            Wir sind Journalisten und Investoren – <strong>keine zugelassenen Anlageberater</strong>.
            Alle Inhalte auf Grüne Geldanlage dienen der Information und Bildung, nicht der
            individuellen Beratung. Anlageentscheidungen treffen Sie eigenverantwortlich und –
            wo sinnvoll – unter Einbeziehung eines qualifizierten Beraters, der Ihre
            persönliche Situation kennt.
          </p>

          <blockquote>
            Ein Fachportal ist nur so gut wie seine Bereitschaft, eigene Grenzen zu benennen.
          </blockquote>
        </div>
      </section>
      <Footer />
    </div>
  );
}
